module.exports = __webpack_public_path__ + "assets/lessons_tab.ddb22e84.svg";